var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M31.2,62.5C14,62.5,0,48.5,0,31.3S14,0,31.2,0s31.3,14,31.3,31.3S48.5,62.5,31.2,62.5z M31.2,4\n\tC16.2,4,4,16.2,4,31.3c0,15,12.2,27.3,27.3,27.3c15,0,27.3-12.2,27.3-27.3C58.5,16.2,46.3,4,31.2,4z","key":0}),React.createElement("path",{"className":"st1","d":"M26.9,41.3c-0.3,0-0.7-0.1-1-0.3c-0.6-0.4-1-1-1-1.7V22.9c0-0.7,0.4-1.4,1-1.7c0.6-0.4,1.4-0.4,2,0l14.2,8.2\n\tc0.6,0.4,1,1,1,1.7s-0.4,1.4-1,1.7L27.9,41C27.6,41.2,27.3,41.3,26.9,41.3z M28.9,26.4v9.5l8.2-4.7L28.9,26.4z","key":1})]);
}

Play.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 62.5 62.4","style":{"enableBackground":"new 0 0 62.5 62.4"},"xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
